import {get_user_details,get_token } from "@/router";

import AllSubjects from "@/components/GetSubjects/SubjectComponent.vue";
import { client_domain } from "@/main.js";
import { HOME_FEATURE_ICONS } from "@/utils/home_feature_icons";

export default {
  components: {
    AllSubjects
  },

   inject: ['client_features'],
    computed: {
      home_feature_icons() {
        return HOME_FEATURE_ICONS;
      },
    },
    data() {
      return ({
        user_details: {
          "user_role": '',
        },
        token_exists: false,
        community_domain:false,
        tdm_domain:false,
        cbo_domain:false,
        dwypd_domain:false,
        school_domain: false,
        visible_domain: false,
        incident:false,
        marketplace:false
      })
    },
    mounted() {
      this.user_details = get_user_details();
      this.token_exists = get_token();
  },

    methods: {
      toggleSidebar() {
        this.$emit('toggle-sidebar');
      }
    }
  }
